// Keep the public design preview independent of live account, payment, and analytics bootstrapping.
const isPhotosPreview = /^\/ai-photos-preview\/?$/.test(window.location.pathname);
const isPhotosV2 = /^\/ai-photos-v2\/?$/.test(window.location.pathname);

async function startApp() {
  // Separate awaited imports keep Vite's preload lists tied to the selected entry.
  if (isPhotosPreview) {
    await import("./preview-entry");
    return;
  }
  if (isPhotosV2) {
    await import("./photos-v2-entry");
    return;
  }
  await import("./production-entry");
}

void startApp();
